// extracted by css-extract-rspack-plugin
export default {"container":"ImagePreview-module__container__l18Mz","imageElement":"ImagePreview-module__imageElement__PbZ1x"};